import React, { useState } from 'react';
import { AcvtGenHeader } from '../generic-header';
import style from './style.module.scss';
import ArrowIcon from '../../../icons/left-arrow.svg?react';
import { AcvtSupportedLanguages } from '../../../types/acvt';
import { useT } from '../../preview';
import * as Colors from '../../../styles/colors';

export const AcvtGamesPage = (props: {
    /**
     * Kept for backward compatibility — strings come from `useT()`.
     */
    language?: AcvtSupportedLanguages;
    cards: React.ReactNode;
}) => {
    const t = useT();
    const [isIconHovering, setIsIconHovering] = useState(false);

    const handleMouseEnter = () => {
        setIsIconHovering(true);
    };

    const handleMouseLeave = () => {
        setIsIconHovering(false);
    };
    return (
        <>
            <div className={style.games_content}>
                <AcvtGenHeader textColor={Colors.WHITE}>
                    <ArrowIcon
                        fill={isIconHovering ? 'black' : 'white'}
                        style={{ cursor: 'pointer' }}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                        className={style.back_arrow}
                    />
                    {t.games.header}
                </AcvtGenHeader>
                <div className={style.scroll_content}>{props.cards}</div>
            </div>
        </>
    );
};
